import React from 'react'
import { CompanySelect } from '../CompanySelect'
import { SelectInlineInput } from '@ztechapps/webui.input'

export const CompanySelectInlineInput = ({ ...rest }: any) => {
  return <SelectInlineInput {...rest} selectComponent={CompanySelect} />
}
